<form-section [subtitle]="subtitle(6537)" data-testid="manuals">
    @for(manual of manuals.list; track manual.filename){
        <form-link [subtitle]="manual.title"
                     [href]="manuals.path + '/' + manual.filename"
                     [download]="manual.filename">
        </form-link>
    }
</form-section>
